import currency from 'currency.js';
import { getOrderPayments } from './get-order-payments';
export const getOrderPaidAmount = () => { var _a, _b; return (_b = (_a = getOrderPayments()) === null || _a === void 0 ? void 0 : _a.reduce((total, payment) => currency(total).add(payment.value).value, 0)) !== null && _b !== void 0 ? _b : 0; };
